<template>
  <div>
    <!-- Container-fluid starts-->
    <div
      v-if="sector"
      class="container-fluid"
    >
      <div class="row">
        <!-- Sidebar Column -->
        <div class="col-md-3">
          <ActiveRequestsSidebar
            :active-requests-count-by-country="countryNumberCodes"
            @country-selected="updateCountryCodeNew"
          />
        </div>

        <div class="col-md-9">
          <Breadcrumbs
            main-link="welcome"
            :main="$t('dashboardVue.dashboard')"
            :title="sector.name || 'Yüklənir...'"
          />

          <div class="row mb-3">
            <div :class="{'col-lg-7': sector.logistic, 'col-lg-12': !sector.logistic}">
              <div class="lead font-weight-bold">
                {{ sector.name }}
              </div>
            </div>
            <div class="col-lg-7">
              <Multiselect
                v-model="selectedCountry"
                :options="countryOptions"
                :multiple="true"
                :placeholder="$t('selectCountry')"
                :custom-label="customLabel"
                class="form-control"
              />
            </div>
            <div
              v-if="sector.logistic"
              class="col-lg-5"
            >
              <select
                v-model="requestTypeFilter"
                class="form-control"
              >
                <option value="ALL">
                  {{ $t('myRequest.btnSorular') }}
                </option>
                <option value="LGI">
                  {{ $t('newRequestPopupContent.logistikInformasiyaSorusu') }}
                </option>
                <option value="LOG">
                  {{ $t('newRequestPopupContent.logistikQiymtSorusu') }}
                </option>
                <option value="TRS">
                  {{ $t('newRequestPopupContent.trAxtar') }}
                </option>
                <option value="TRK">
                  {{ $t('newRequestPopupContent.trElan') }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-7">
              <div class="mb-4">
                <div class="text-left text-lg-left mt-2">
                  <div class="btn-group w-100">
                    <button
                      class="btn"
                      :class="{
                        'btn-light inactive-tab': activeTab !== 'request',
                        'btn-dark active-tab': activeTab === 'request'
                      }"
                      @click="activeTab = 'request'"
                    >
                      {{ $t('myCabinetMenu.sorular') }} <span
                        v-if="requestCount('request')"
                        class="ml-2 badge badge-success"
                      >{{
                        requestCount('request')
                      }}</span>
                    </button>
                    <button
                      class="btn"
                      :class="{
                        'btn-light inactive-tab': activeTab !== 'offer',
                        'btn-dark active-tab': activeTab === 'offer'
                      }"
                      @click="activeTab = 'offer'"
                    >
                      {{ $t('sector.tkliflr') }} <span
                        v-if="requestCount('offer')"
                        class="ml-2 badge badge-success"
                      >{{
                        requestCount('offer')
                      }}</span>
                    </button>
                    <button
                      class="btn"
                      :class="{
                        'btn-light inactive-tab': activeTab !== 'archive',
                        'btn-dark active-tab': activeTab === 'archive'
                      }"
                      @click="activeTab = 'archive'"
                    >
                      {{ $t('sector.arxiv') }}
                    </button>
                  </div>
                </div>
              </div>

              <div
                v-if="requestList.length < 1"
                class="my-4 alert alert-info"
              >
                {{ $t('requestsByType.axtaraUyunSoruTaplmad') }}
              </div>

              <div class="card">
                <div class="card-body">
                  <div
                    v-for="item in shuffledList"
                    :key="item.request?.id || item.product?.id"
                  >
                    <template v-if="item.type === 'request'">
                      <RequestItem
                        :active-tab="activeTab"
                        :is-archive="!available || activeTab === 'archive'"
                        :build-long-id="buildLongId(item.request.id)"
                        :r="item.request"
                        :sector="sector"
                      />
                    </template>
                    <template v-else>
                      <ProductItem :product="item.product" />
                    </template>
                    <hr class="my-2">
                  </div>
                </div>
              </div>

              <div class="my-4 text-center">
                <button
                  v-if="activeTab === 'request'"
                  class="btn btn-outline-primary"
                  @click="activeTab = 'archive'"
                >
                  {{ $t('sector.arxivlnmiSorularaBax') }}
                </button>
              </div>
            </div>

            <div
              v-if="sector"
              class="col-lg-5"
            >
              <div class="card">
                <div class="card-header font-weight-bold">
                  {{ $t('sector.faliyytSahsiItiraklar') }}
                </div>
                <div
                  v-if="sector.description"
                  class="card-body"
                >
                  <p>{{ sector.description }}</p>
                </div>
                <div class="list-group list-group-flush">
                  <div
                    v-for="s in statistics"
                    :key="s.profileType"
                    class="list-group-item"
                    style="cursor: pointer"
                    @click="showSectorCompanies(s.profileType)"
                  >
                    <div class="d-flex justify-content-between">
                      <div>
                        <span class="font-weight-bold">{{ getProfileName(s.profileType) }}</span>
                      </div>
                      <div class="d-flex">
                        <span>{{ $t('sector.istifadi', {counter: s.counter}) }}</span>
                        <feather
                          type="chevron-right"
                          size="20"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="profile === 'PROCUREMENT'">
                <div class="card">
                  <div class="card-header font-weight-bold">
                    {{ $t('requestsByType.tdarkTsdiqFormalar') }}
                  </div>
                  <div class="card-body">
                    <p>{{ $t('sector.sccPortalAdminiTrfindnRsmiTsdiqEdilmiSatnalanTkila') }}</p>

                    <p v-if="vendorManagementAvailable">
                      <router-link
                        class="btn btn-success"
                        :to="{ name: 'vendorManagementDashboard' }"
                      >
                        {{ $t('newInfoRequest.vendorManagement') }}
                      </router-link>
                    </p>
                    <p v-else>
                      <router-link
                        class="btn btn-success"
                        :to="{ name: 'addOnPage' }"
                      >
                        {{ $t('sector.vendorManagementiAktivldir') }}
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card">
                  <div class="card-header font-weight-bold">
                    {{ $t('requestsByType.tdarkTsdiqFormalar') }}
                  </div>
                  <div class="card-body">
                    <p v-if="formList.length > 0">
                      {{ $t('requestsByType.satnalanTkilatlarnTsdiqlnmiTdarkSiyahsnaDmkNAadakT') }}
                    </p>

                    <p v-else>
                      {{ $t('sector.buSektordaHazrdaHeBirSatinalanTkilatnTdarkDyrlndir') }}
                    </p>
                  </div>
                </div>

                <div class="card">
                  <div
                    v-for="f in formsGrouped"
                    class="card-body"
                  >
                    <div
                      class="d-flex justify-content-between mt-2 cursor-pointer"
                      @click.prevent="openRatingPopup({ company: f.company, profile: 'PROCUREMENT' })"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          class="rounded-circle user-image border mr-2"
                          :src="getPhoto(f.company.logo, 'thumbnailCropped')"
                          alt=""
                          style="width: 50px"
                        >
                        <div class="about">
                          <div class="name">
                            {{ f.company.name }} {{ getCompanyFormat(f.company.format) }}
                          </div>
                          <div class="text-secondary small">
                            {{ $t('sector.ven', {taxId: f.company.taxId}) }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <StarRatingView
                          :count="f.company.procurementRateCount"
                          :total="f.company.procurementRateTotal"
                          :single-star="true"
                        />
                      </div>
                    </div>

                    <div class="list-group list-group-flush mt-2 ml-2">
                      <router-link
                        v-for="fm in f.forms"
                        target="_blank"
                        :to="{ name: 'vendorFormView', params: { id: fm.id } }"
                        class="list-group-item text-secondary px-0 d-flex justify-content-between align-items-center"
                      >
                        {{ fm.name }}
                        <i class="fa fa-chevron-right" />
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container Ends-->
    </div>

    <b-modal
      id="modal-sector-statistics"
      centered
      :title="`${getProfileName(statisticsPopupProfile)} şirkətlər`"
      scrollable
      class="theme-modal"
      :hide-footer="true"
    >
      <SectorCompaniesModalContent
        :sector="sector"
        :profile="statisticsPopupProfile"
        @openRatingPopup="openRatingPopup($event)"
      />
    </b-modal>

    <b-modal
      id="modal-company-rate-statists"
      centered
      :title="`${getProfileName(openCompanyRatingStatisticPopupProfile)} profili`"
      ok-only
      ok-title="bağla"
      class="theme-modal"
    >
      <CompanyRateStatistics
        v-if="openCompanyRatingStatisticPopup > 0"
        :show-company="true"
        :company-id="openCompanyRatingStatisticPopup"
        :profile-type="openCompanyRatingStatisticPopupProfile"
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ActiveRequestsSidebar from '@/pages/scc/request/lists/ActiveRequestsSidebar.vue';
import {
  getSector,
  getSectorArchive,
  getSectorCountryNumber,
  getVendorManagementStatus,
  userAccounts,
} from '@/repositories/GeneralDataRepository';
import {mediaBase} from '@/repositories/Repository';
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from '@/repositories/Utils';
import RequestItem from '@/components/parts/RequestItem.vue';
import {getSectorForms} from '@/repositories/VendorManagementRepository';
import SectorCompaniesModalContent from '@/pages/scc/request/lists/SectorCompaniesModalContent.vue';
import CompanyRateStatistics from '@/pages/scc/company/CompanyRateStatistics.vue';
import StarRatingView from '@/pages/scc/utils/StarRatingView.vue';
import Multiselect from 'vue-multiselect';
import ProductItem from "@/pages/scc/products/ProductItem.vue";

export default {
  components: {
    Multiselect,
    ActiveRequestsSidebar,
    StarRatingView,
    CompanyRateStatistics,
    SectorCompaniesModalContent,
    RequestItem,
    ProductItem  // Register the new ProductItem component
  },
  data() {
    return {
      selectedCountry: [this.$t('countries.ALL')], // The selected country
      countryCodes: ['ALL'], // This will hold the corresponding country codes
      mediaBase: mediaBase,
      countryNumberCodes: null,
      profiles: [],
      dashboard: [],
      announcements: [],
      sector: {},
      statistics: [],
      requests: [],
      products: [],
      activeTab: 'request',
      available: false,
      requestTypeFilter: 'ALL',
      formList: [],
      statisticsPopupProfile: '',

      vendorManagementAvailable: false,

      openCompanyRatingStatisticPopup: 0,
      openCompanyRatingStatisticPopupProfile: '',
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
      position: (state) => state.auth.position,
    }),
    countryOptions() {
      const countries = this.$t('countries'); // Fetches the countries translations based on the current locale
      return Object.keys(countries).map((code) => {
        return {name: countries[code], code}; // The label that Vue Multiselect will display
      });
    },
    customLabel(option) {
      return option.code; // Assumes that each option is an object with a 'name' property
    },
    requestList() {
      let list = [];
      this.requests.forEach((r) => {
        if (this.activeTab === 'offer') {
          if (r.requestType === 'OFR') {
            list.push(r);
          }
        } else if (this.activeTab === 'request') {
          if (r.requestType !== 'OFR' && (this.requestTypeFilter === 'ALL' || this.requestTypeFilter === r.requestType)) {
            list.push(r);
          }
        } else if (this.activeTab === 'archive') {
          if (r.requestType !== 'OFR' && (this.requestTypeFilter === 'ALL' || this.requestTypeFilter === r.requestType)) {
            list.push(r);
          }
        }
      });
      return list;
    },
    formsGrouped() {
      let list = {};

      this.formList.forEach((f) => {
        if (!list.hasOwnProperty(f.company.id)) {
          list[f.company.id] = {
            company: f.company,
            forms: [],
          };
        }

        list[f.company.id]['forms'].push(f);
      });

      return list;
    },
    shuffledList() {
      // Shuffle the products array
      let shuffledProducts = [...this.products];
      for (let i = shuffledProducts.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledProducts[i], shuffledProducts[j]] = [shuffledProducts[j], shuffledProducts[i]];
      }

      // Interleave the requests and shuffled products
      let interleavedList = [];
      let requestIndex = 0;
      let productIndex = 0;

      while (requestIndex < this.requestList.length) {
        // Add up to 3 requests
        for (let i = 0; i < 3 && requestIndex < this.requestList.length; i++) {
          interleavedList.push({type: 'request', request: this.requestList[requestIndex]});
          requestIndex++;
        }

        // Add one product if available
        if (productIndex < shuffledProducts.length) {
          interleavedList.push({type: 'product', product: shuffledProducts[productIndex]});
          productIndex++;
        }
      }

      // If there are any remaining products, add them at the end
      while (productIndex < shuffledProducts.length) {
        interleavedList.push({type: 'product', product: shuffledProducts[productIndex]});
        productIndex++;
      }

      return interleavedList;
    },
  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then((data) => {
        this.profiles = data;
      });
    },
    selectedCountry() {
      this.updateCountryCodes();
    },
    activeTab(newValue, oldValue) {
      if (newValue === 'archive') {
        this.requests = [];
        this.getArchiveList();
      } else {
        if (oldValue === 'archive') {
          this.requests = [];
          this.getNormalList();
        }
      }
    },
  },
  mounted() {
    this.getNormalList();
    this.getNumberOfCountryRequest();
    if (this.profile === 'SUPPLIER') {
      getSectorForms(this.token, this.$route.params['sectorId']).then((list) => {
        this.formList = list;
      });
    }

    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = code === 200;
    });
  },
  methods: {
    companyProfiles(companyId) {
      let list = [];
      this.profiles.forEach((p) => {
        if (p.company.id === companyId) {
          list.push(p);
        }
      });
      return list;
    },
    getCountryCode(countryName) {
      const countries = this.$t('countries'); // Assuming this gives an object like { az: "Azerbaijan", ... }
      // Find the country code by searching through the countries object
      const countryCode = Object.keys(countries).find((key) => countries[key] === countryName);
      return countryCode || null; // Return the country code if found, otherwise return null
    },
    updateCountryCodes() {
      this.countryCodes = this.selectedCountry.map((countryName) => this.getCountryCode(countryName));
      this.getNormalList();
    },
    updateCountryCodeNew(country) {
      this.countryCodes = [country];
      this.selectedCountry = this.$t('countries')[country];
      this.getNormalList();
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    requestCount(type) {
      let count = 0;
      this.requests.forEach((r) => {
        if (r.isRead < 1) {
          if (type === 'offer') {
            if (r.requestType === 'OFR') {
              count++;
            }
          } else {
            if (r.requestType !== 'OFR') {
              count++;
            }
          }
        }
      });
      return count;
    },
    getNumberOfCountryRequest() {
      getSectorCountryNumber(this.token, this.$route.params['sectorId'], this.$i18n.locale).then((data) => {
        if (data.code === 200) {
          this.countryNumberCodes = data.main;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    getNormalList() {
      getSector(this.token, this.$route.params['sectorId'], this.$i18n.locale, this.countryCodes).then((data) => {
        if (data.code === 200) {
          this.sector = data.sector;
          this.statistics = data.statistics;
          this.requests = data.requests;
          this.products = data.products;
          this.available = data.available || data.sector.logistic;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    getArchiveList() {
      getSectorArchive(this.token, this.$route.params['sectorId']).then((data) => {
        if (data.code === 200) {
          this.requests = data.requests;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    showSectorCompanies(profile) {
      this.statisticsPopupProfile = profile;

      this.$bvModal.show('modal-sector-statistics');
    },
    openRatingPopup({company, profile}) {
      this.$bvModal.show('modal-company-rate-statists');
      this.openCompanyRatingStatisticPopup = company.id;
      this.openCompanyRatingStatisticPopupProfile = profile;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .active-tab {
  background: #3a4b68 !important;
  font-size: 14px;

  &:hover,
  &:focus,
  &:active {
    background: #3a4b68 !important;
  }
}

::v-deep .inactive-tab {
  background: rgba(#8b95a6, 0.1) !important;
  border-color: rgba(#8b95a6, 0.1) !important;

  &:hover,
  &:focus,
  &:active {
    background: rgba(#8b95a6, 0.1) !important;
  }
}
</style>
